/* import __COLOCATED_TEMPLATE__ from './monitor-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class MonitorCardComponent extends Component
{
	@service socketGuru;
	@tracked log = [];

	constructor()
	{
		super(...arguments);
		this._boundHandleEvent = this._handleEvent.bind(this);
		this.socketGuru.events.addEventListener('newEvent', this._boundHandleEvent);
	}

	willDestroy()
	{
		super.willDestroy(...arguments);
		this.socketGuru.events.removeEventListener('newEvent', this._boundHandleEvent);
	}

	_handleEvent(event)
	{
		const { eventName, data } = event.detail;
		if(eventName == "stdErr" || eventName == "stdOut")
		{
			let parsedData = JSON.parse(data);
			var message = String.fromCharCode.apply(null, parsedData.message.data);
			// Use spread operator to create a new array for reactivity
			this.log = [...this.log, message];
		}
	}
}
